

import React, {
    ChangeEvent,
    useCallback,
    useEffect,
    useMemo,
    useState,
    useRef,
} from 'react';
import { FaLightbulb } from "react-icons/fa";
import { getCreator } from 'utils/creator/creator';
import { getCompany } from 'utils/company/companyService';
import { HiLink } from 'react-icons/hi';
import { IoAlert } from "react-icons/io5";
import { MdPsychology } from "react-icons/md";
import { FaChartLine } from 'react-icons/fa';
import { FaClipboardList } from 'react-icons/fa';
import { MdAssessment } from "react-icons/md";
import { MdOutlineAssessment } from "react-icons/md";
import { FileText, Layers, Settings } from 'lucide-react';
import { FaPuzzlePiece } from "react-icons/fa6";
import { MdOutlineSwipe } from "react-icons/md";
import { TbDragDrop2 } from "react-icons/tb";
import { Tabs, TabsTrigger, TabsList, TabsContent } from '@radix-ui/react-tabs';
import InputField from 'components/fields/InputField';
import {
    Box,
    Text,
    Flex,
    Checkbox,
    Button,
    Icon,
    List,
    ListItem,
    Img,
    Textarea,
    Input,
    Divider,
    Switch,
    Tooltip,
    SimpleGrid
} from '@chakra-ui/react';
import { Select as ChakraSelect } from '@chakra-ui/react';
import {
    MdAdd,
    MdCloudUpload,
    MdInbox,
    MdNote,
    MdNoteAdd,
    MdTextsms,
    MdDelete,
    MdOutlineStickyNote2,
} from 'react-icons/md';
import { BiSolidDuplicate } from 'react-icons/bi';
import Menu from '../components/Navigate';
import StrightConector from '../components/dragNdrop/strightConector';

import { TbHandClick, TbMessages } from 'react-icons/tb';
import { FaAward } from 'react-icons/fa6';
interface PropsNote {
    formData?: any;
    reviews?: any;
    id?: number;
    language?: any;
    seq?: any;
    index?: number;
    handleNDI?: any;
    name?: any;
    handleInput?: any;
    input?: any;
    getSeq?: any;
    handleMiniNDI?: any;
    duplicateSeq?: any;
    delSeq?: any;
    alphabet?: any;
    setNavigation: any;
    handleBlock: any;
    items?: any;
    formDataGamelanguageCode?: any;
    handleSelectBlock?: any;
    showSelectBlock?: any;
    setSelectBlock?: any;
    validation?: any;
    currentseq?: any;
    ShowReview?: any;
    targetSequence?: any;
    blockOnFocusHanlder: any;
    blockOnBlurHanlder: any;
}
interface Block {
    blockPrimarySequence: string;
    // Add other properties as needed
    content: string | undefined; // Adjust the type according to your data structure
}
interface GameRound {
    id: number;
    // add more fields later if needed
}

interface GameSettings {
    pointsPerCorrect: number;
    timerEnabled: boolean;
    timePerRound: number;
    allowReplay: boolean;
}

interface WehaveChooseConfig {
    title: string;
    subtitle: string;
    characterName: string;
    topicSubtitle: string;
    rounds: GameRound[];
    settings: GameSettings;
}

type OptionField = "optionText" | "feedback" | "guidance" | "isCorrect";

interface Option {
    optionText: string;
    feedback: string;
    guidance: string;
    isCorrect: boolean;
}

interface Round {
    Statement: string;
    feedback: string;
    correctAnswer: string;
}


const DEFAULT_WEHAVECHOOSE_CONFIG: WehaveChooseConfig = {
    title: "",
    subtitle: "",
    characterName: "",
    topicSubtitle: "",
    rounds: [], // ✅ now typed as GameRound[]
    settings: {
        pointsPerCorrect: 100,
        timerEnabled: false,
        timePerRound: 30,
        allowReplay: false,
    },
};


const DragForNowCompo: React.FC<PropsNote> = ({
    formData,
    targetSequence,

    seq,
    index,
    name,
    handleInput,
    input,
    getSeq,
    duplicateSeq,
    delSeq,

    setNavigation,
    handleBlock,
    handleSelectBlock,
    items,

    showSelectBlock,
    handleNDI,

    validation,
}) => {
    console.log('inputssss', input);

    // Update scenario options to include API response values
    const getScenarioOptions = useMemo(() => {
        const options = [];
        const blockData = input?.[`DragForNow${seq.input}`];

        // Add left option if it exists
        if (blockData?.leftOption) {
            options.push({
                label: ` ${blockData.leftOption}`,
                value: blockData.leftOption
            });
        }

        // Add right option if it exists
        if (blockData?.rightOption) {
            options.push({
                label: ` ${blockData.rightOption}`,
                value: blockData.rightOption
            });
        }

        return options;
    }, [input, seq.input]);

    const textareaRef = useRef(null);

    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = 'auto';
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
        }
    }, [input?.[`DragForNow${seq.input}`]?.DragForNow]);

    const customButtonStyles = {
        display: 'flex',
        alignItems: 'center',
        borderRadius: '15px',
        borderColor: '#ccc', // Optional: Change border color for disabled state
        borderWidth: '1px', // Add this line to set the border width
        borderStyle: 'solid', // Add this line to set the border style
        cursor: 'not-allowed', // Optional: Change cursor for disabled state
        padding: '5px 10px',
        width: '144px',
        // textAlign: "left",
        outerWidth: '10px',
        outline: 'none',
    };

    const customStyles = {
        menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
        control: (provided: any, state: any) => ({
            ...provided,
            borderRadius: '15px',
            borderColor: 'inherit',
            background: 'transparent',
            // height: '45px',
            width: '130px',
            padding: '0 !important',
        }),
    };

    const handleMiniNDInewblock = (value?: any, seq?: any, i?: any) => {
        handleNDI(value);

        const maxInputItem = items.reduce(
            (max: any, item: any) => (item.input > max.input ? item : max),
            items[0],
        );
        let input = maxInputItem?.input ? maxInputItem.input + 1 : 1;
        if (value !== '') {
            handleSelectBlock(
                { value: input },
                input,
                `DragForNow${seq.input}`,
                `DragForNow${seq.input}`,
            );
        }
    };
    const [showReflectionQuestions, setShowReflectionQuestions] = useState(false);
    //  const [showScenarioCompletion, setshowScenarioCompletion] = useState(false);
    // const [showWrongAnswer, setShowWrongAnswer] = React.useState(
    //     !!input?.[`DragForNow${seq.input}`]?.answerguide
    // );



    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('user'));
        const userId = user?.data?.id;

        console.log("Login user id:", userId);

        if (userId) {
            // First get user details including company ID
            getCreator(userId)
                .then(userResult => {
                    console.log('Complete login user data:', userResult);

                    if (userResult?.data?.ctCompanyId) {
                        const companyId = userResult.data.ctCompanyId;
                        console.log('User company ID:', companyId);

                        // Now fetch company details using company ID
                        return getCompany(companyId)
                            .then(companyResult => {
                                console.log('Company details:', companyResult);

                                // Get company name - data is an array, so use [0]
                                const companyName = companyResult?.data?.[0]?.cpCompanyName;

                                console.log('User belongs to company:', companyName);

                                // Now you can use companyName for your logic
                                if (companyName?.toLowerCase() === 'cognizant' || 'CTS') {
                                    setShowReflectionQuestions(true);
                                    //  setshowScenarioCompletion(true);
                                } else {
                                    setShowReflectionQuestions(false);
                                    //  setshowScenarioCompletion(false);
                                }
                            });
                    } else {
                        console.log('User has no company ID');
                        setShowReflectionQuestions(false);
                        //  setshowScenarioCompletion(false);
                    }
                })
                .catch(error => {
                    console.error('Error fetching user or company details:', error);
                    setShowReflectionQuestions(false);
                    //  setshowScenarioCompletion(false);
                });
        }
    }, []);
    const MiniBox1 = (props: {
        seq?: any;
        i?: number;
        name?: any;
        bodyRef?: any;
    }) => {
        const { seq, i, name, bodyRef } = props;
        return (
            <Box
                position={'absolute'}
                background={'#fff'}
                p={'10px'}
                boxShadow={'1px 1px 17px #69627914'}
                borderRadius={'8px'}
                zIndex={99}
                className="MiniShowBox"
            >
                <List cursor={'pointer'}>
                    <ListItem
                        onClick={() => handleMiniNDInewblock('Note', seq, i)}
                        p={'10px'}
                        display={'flex'}
                        alignItems={'center'}
                        borderBottom={'2px solid #f1f1f170'}
                    >
                        <Icon as={MdOutlineStickyNote2} mr={'10px'} color={'#3311db'} />
                        Note
                    </ListItem>

                    <ListItem
                        onClick={() => handleMiniNDInewblock('Dialog', seq, i)}
                        p={'10px'}
                        display={'flex'}
                        alignItems={'center'}
                        borderBottom={'2px solid #f1f1f170'}
                    >
                        <Icon as={TbMessages} mr={'10px'} color={'#3311db'} />
                        Dialog
                    </ListItem>
                    <ListItem
                        onClick={() => handleMiniNDInewblock('Interaction', seq, i)}
                        p={'10px'}
                        display={'flex'}
                        alignItems={'center'}
                    >
                        <Icon as={TbHandClick} mr={'10px'} color={'#3311db'} />
                        Interaction
                    </ListItem>
                    <ListItem
                        onClick={() => handleMiniNDInewblock('Link', seq, i)}
                        p={'10px'}
                        display={'flex'}
                        alignItems={'center'}
                        borderBottom={'2px solid #f1f1f170'}
                    >
                        <Icon as={HiLink} mr={'10px'} color={'#3311db'} />
                        Link
                    </ListItem>
                    {showReflectionQuestions && (
                        <>
                            <ListItem
                                onClick={() => handleMiniNDInewblock('Reflection', seq, i)}
                                p={'10px'}
                                display={'flex'}
                                alignItems={'center'}
                                borderBottom={'2px solid #f1f1f170'}
                            >
                                <Icon as={MdPsychology} mr={'10px'} color={'#3311db'} />
                                Reflection
                            </ListItem>
                            <ListItem
                                onClick={() => handleMiniNDInewblock('Overview', seq, i)}
                                p={'10px'}
                                display={'flex'}
                                alignItems={'center'}
                                borderBottom={'2px solid #f1f1f170'}
                            >
                                <Icon as={FaClipboardList} mr={'10px'} color={'#3311db'} />
                                Overview
                            </ListItem>
                            <ListItem
                                onClick={() => handleMiniNDInewblock('KeyInsights', seq, i)}
                                p={'10px'}
                                display={'flex'}
                                alignItems={'center'}
                                borderBottom={'2px solid #f1f1f170'}
                            >
                                <Icon as={FaChartLine} mr={'10px'} color={'#3311db'} />
                                KeyInsights
                            </ListItem>
                            <ListItem
                                onClick={() => handleMiniNDInewblock('PreAssessment', seq, i)}
                                p={'10px'}
                                display={'flex'}
                                alignItems={'center'}
                                borderBottom={'2px solid #f1f1f170'}
                            >
                                <Icon as={MdAssessment} mr={'10px'} color={'#3311db'} />
                                PreAssessment
                            </ListItem>
                            <ListItem
                                onClick={() => handleMiniNDInewblock('PostAssessment', seq, i)}
                                p={'10px'}
                                display={'flex'}
                                alignItems={'center'}
                                borderBottom={'2px solid #f1f1f170'}
                            >
                                <Icon as={MdOutlineAssessment} mr={'10px'} color={'#3311db'} />
                                PostAssessment
                            </ListItem>

                            {formData?.gameScenarioCompletion === "true" &&

                                <ListItem
                                    onClick={() => handleMiniNDInewblock('ScenarioCompletion', seq, i)}
                                    p={'10px'}
                                    display={'flex'}
                                    alignItems={'center'}
                                    borderBottom={'2px solid #f1f1f170'}
                                >
                                    <Icon as={FaAward} mr={'10px'} color={'#3311db'} />
                                    ScenarioCompletion
                                </ListItem>
                            }
                        </>
                    )}
                    <ListItem
                               onClick={() => handleMiniNDInewblock('WehaveChoose', seq, i)}
                               p={'10px'}
                               display={'flex'}
                               alignItems={'center'}
                               borderBottom={'2px solid #f1f1f170'}
                             >
                               <Icon as={FaPuzzlePiece} mr={'10px'} color={'#3311db'} />
                               WehaveChoose
                             </ListItem>
                                        <ListItem
                               onClick={() => handleMiniNDInewblock('SwipeMiniGame', seq, i)}
                               p={'10px'}
                               display={'flex'}
                               alignItems={'center'}
                               borderBottom={'2px solid #f1f1f170'}
                             >
                               <Icon as={MdOutlineSwipe} mr={'10px'} color={'#3311db'} />
                               Swipe
                             </ListItem>
                                        <ListItem
                               onClick={() => handleMiniNDInewblock('DragForNow', seq, i)}
                               p={'10px'}
                               display={'flex'}
                               alignItems={'center'}
                               borderBottom={'2px solid #f1f1f170'}
                             >
                               <Icon as={TbDragDrop2} mr={'10px'} color={'#3311db'} />
                               Drag For Now 
                             </ListItem>
                </List>
            </Box>
        );
    };

    const justClick = (event: any, seq: any) => {
        const element = event.target;
        element.focus();
    };





    const createOption = () => ({
        optionText: "",
        feedback: "",
        guidance: "",
        isCorrect: false,
    });

    const createRound = () => ({
        Statement: "",
        feedback: "",
        correctAnswer: "",
    });

    // Enhanced round structure for CategoryMatching mode
    const createCategoryRound = () => ({
        categories: [
            { categoryName: "" },
            { categoryName: "" }
        ],
        statements: [
            {
                statementText: "",
                feedback: "",
                selectedCategory: "" // Add selected category field
            }
        ]
    });

    // Enhanced round structure for Ranking mode
    const createRankingRound = () => ({
        statements: [
            {
                statementText: "",
                correctAnswer: "",
                feedback: ""
            }
        ]
    });

    const [rounds, setRounds] = useState<Round[]>([]);
    const [categoryRounds, setCategoryRounds] = useState<any[]>([]);
    const [rankingRounds, setRankingRounds] = useState<any[]>([]);

    console.log('rounds:', rounds);
    console.log('categoryRounds:', categoryRounds);
    console.log('rankingRounds:', rankingRounds);

    const [isHydrated, setIsHydrated] = useState(false);

    const weHaveChoose = input?.[`DragForNow${seq.input}`];
    console.log('dfffrff', weHaveChoose);
    const [replayValue, setReplayValue] = useState<"On" | "Off">("Off");

    const rangeValue = Number(weHaveChoose?.timer ?? 0);

    const rawTimerEnabled = weHaveChoose?.timerEnabled;

    // normalize EVERYTHING to boolean
    // Backend: 1 = enabled, 0 = disabled, null = disabled
    const timerEnabled =
        rawTimerEnabled === true ||
        rawTimerEnabled === "true" ||
        rawTimerEnabled === 1 ||
        rawTimerEnabled === "1";

    const normalizedTimerEnabled = timerEnabled;

    const isInitiallyDisabled =
        rawTimerEnabled === false ||
        rawTimerEnabled === "false" ||
        rawTimerEnabled === 0 ||
        rawTimerEnabled === "0" ||
        rawTimerEnabled == null;

    const [timerUnlocked, setTimerUnlocked] = useState(false);
    const isSwitchDisabled = isInitiallyDisabled && !timerUnlocked;
    const isSwitchChecked = normalizedTimerEnabled;
    const rangeEnabled = normalizedTimerEnabled;

    const rawAnswerGuideEnabled =
        weHaveChoose?.answerGuideEnabled;

    // normalize EVERYTHING to boolean
    // Backend: 1 = enabled, 0 = disabled, null = disabled
    const isAnswerGuideEnabled =
        rawAnswerGuideEnabled === true ||
        rawAnswerGuideEnabled === "true" ||
        rawAnswerGuideEnabled === 1 ||
        rawAnswerGuideEnabled === "1";

    useEffect(() => {
        if (weHaveChoose?.ShowReplay === "On" || weHaveChoose?.ShowReplay === "Off") {
            setReplayValue(weHaveChoose.ShowReplay);
        }
    }, [weHaveChoose?.ShowReplay]);


    const addRound = () => {
        setRounds(prev => [...prev, createRound()]);
    };

    type RoundField = "Statement" | "feedback" | "correctCategory";

    const updateRound = (
        roundIndex: number,
        field: RoundField,
        value: string
    ) => {
        setRounds(prev => {
            const copy = [...prev];
            copy[roundIndex] = {
                ...copy[roundIndex],
                [field]: value,
            };
            return copy;
        });
    };








    const deleteRound = (roundIndex: number) => {
        setRounds((prev) => {
            if (prev.length <= 1) return prev;
            return prev.filter((_, i) => i !== roundIndex);
        });
    };

    // Category Matching Round Management
    const addCategoryRound = () => {
        setCategoryRounds(prev => [...prev, createCategoryRound()]);
    };

    const deleteCategoryRound = (roundIndex: number) => {
        setCategoryRounds((prev) => {
            if (prev.length <= 1) return prev;
            return prev.filter((_, i) => i !== roundIndex);
        });
    };

    const updateCategoryRound = (
        roundIndex: number,
        field: 'categories' | 'statements',
        subIndex: number,
        subField: string,
        value: string
    ) => {
        setCategoryRounds(prev => {
            const copy = [...prev];
            if (field === 'categories') {
                copy[roundIndex].categories[subIndex] = {
                    ...copy[roundIndex].categories[subIndex],
                    [subField]: value,
                };
            } else if (field === 'statements') {
                copy[roundIndex].statements[subIndex] = {
                    ...copy[roundIndex].statements[subIndex],
                    [subField]: value,
                };
            }
            return copy;
        });
    };

    const addCategory = (roundIndex: number) => {
        setCategoryRounds(prev => {
            const copy = [...prev];
            copy[roundIndex].categories.push({ categoryName: "" });
            return copy;
        });
    };

    const deleteCategory = (roundIndex: number, categoryIndex: number) => {
        setCategoryRounds(prev => {
            const copy = [...prev];
            if (copy[roundIndex].categories.length > 2) {
                copy[roundIndex].categories = copy[roundIndex].categories.filter((_: any, i: number) => i !== categoryIndex);
            }
            return copy;
        });
    };

    const addStatement = (roundIndex: number) => {
        setCategoryRounds(prev => {
            const copy = [...prev];
            copy[roundIndex].statements.push({ statementText: "", feedback: "" });
            return copy;
        });
    };

    const deleteStatement = (roundIndex: number, statementIndex: number) => {
        setCategoryRounds(prev => {
            const copy = [...prev];
            if (copy[roundIndex].statements.length > 1) {
                copy[roundIndex].statements = copy[roundIndex].statements.filter((_: any, i: number) => i !== statementIndex);
            }
            return copy;
        });
    };

    // Ranking Round Management
    const addRankingRound = () => {
        setRankingRounds(prev => [...prev, createRankingRound()]);
    };

    const deleteRankingRound = (roundIndex: number) => {
        setRankingRounds((prev) => {
            if (prev.length <= 1) return prev;
            return prev.filter((_, i) => i !== roundIndex);
        });
    };

    const updateRankingRound = (
        roundIndex: number,
        field: 'statements',
        subIndex: number,
        subField: string,
        value: string
    ) => {
        setRankingRounds(prev => {
            const copy = [...prev];
            if (field === 'statements') {
                copy[roundIndex].statements[subIndex] = {
                    ...copy[roundIndex].statements[subIndex],
                    [subField]: value,
                };
            }
            return copy;
        });
    };

    const addRankingStatement = (roundIndex: number) => {
        setRankingRounds(prev => {
            const copy = [...prev];
            copy[roundIndex].statements.push({ statementText: "", correctAnswer: "", feedback: "" });
            return copy;
        });
    };

    const deleteRankingStatement = (roundIndex: number, statementIndex: number) => {
        setRankingRounds(prev => {
            const copy = [...prev];
            if (copy[roundIndex].statements.length > 1) {
                copy[roundIndex].statements = copy[roundIndex].statements.filter((_: any, i: number) => i !== statementIndex);
            }
            return copy;
        });
    };





    // useEffect(() => {
    //     const blockData = input?.[`DragForNow${seq.input}`];
    //     if (!blockData || isHydrated) return;

    //     const parsed = safeParseJSON(blockData.roundLogic);

    //     if (parsed) {
    //         const uiRounds = convertRoundLogicToRounds(parsed);
    //         setRounds(uiRounds.length ? uiRounds : [createRound()]);
    //     } else {
    //         setRounds([createRound()]);
    //     }

    //     setIsHydrated(true);
    // }, [input, seq?.input, isHydrated]);

    useEffect(() => {
        const blockData = input?.[`DragForNow${seq.input}`];
        if (!blockData || isHydrated) return;

        const parsed = safeParseJSON(blockData.roundLogic);
        const gameMode = blockData.GameMode;

        if (!parsed) {
            setRounds([createRound()]);
            setRankingRounds([createRankingRound()]);
            setCategoryRounds([createCategoryRound()]);
            setIsHydrated(true);
            return;
        }

        if (gameMode === "Ranking") {
            const ranking = convertRankingRoundLogic(parsed);
            setRankingRounds(ranking.length ? ranking : [createRankingRound()]);
        }

        if (gameMode === "CategoryMatching") {
            const categories = convertCategoryRoundLogic(parsed);
            setCategoryRounds(categories.length ? categories : [createCategoryRound()]);
        }

        if (!gameMode || gameMode === "Traditional") {
            const traditional = convertRoundLogicToRounds(parsed);
            setRounds(traditional.length ? traditional : [createRound()]);
        }

        setIsHydrated(true);
    }, [input, seq?.input, isHydrated]);





    const buildRoundLogicPayload = (rounds: Round[]) => {
        const payload: any = {};

        rounds.forEach((round, index) => {
            payload[`round${index + 1}`] = {
                Statement: round.Statement,
                feedback: round.feedback,
                correctAnswer: round.correctAnswer,
            };
        });

        return payload;
    };

    // Build Category Matching payload
    const buildCategoryMatchingPayload = (categoryRounds: any[]) => {
        const payload: any = {};

        categoryRounds.forEach((round, index) => {
            const roundPayload: any = {
                categories: {},
                statements: {}
            };

            // Build categories with numbered keys
            round.categories.forEach((category: any, cIndex: number) => {
                roundPayload.categories[`categoryName${cIndex + 1}`] = category.categoryName;
            });

            // Build statements with numbered keys
            round.statements.forEach((statement: any, sIndex: number) => {
                roundPayload.statements[`statementText${sIndex + 1}`] = statement.statementText;
                roundPayload.statements[`feedback${sIndex + 1}`] = statement.feedback;
                // Add selected category field
                roundPayload.statements[`selectedCategory${sIndex + 1}`] = statement.selectedCategory || '';
            });

            payload[`categoryRound${index + 1}`] = roundPayload;
        });

        return payload;
    };

    // Build Ranking payload
    const buildRankingPayload = (rankingRounds: any[]) => {
        const payload: any = {};

        rankingRounds.forEach((round, index) => {
            const roundPayload: any = {
                statements: {}
            };

            // Build statements with numbered keys
            round.statements.forEach((statement: any, sIndex: number) => {
                roundPayload.statements[`statementText${sIndex + 1}`] = statement.statementText;
                roundPayload.statements[`correctAnswer${sIndex + 1}`] = statement.correctAnswer;
                roundPayload.statements[`feedback${sIndex + 1}`] = statement.feedback;
            });

            payload[`rankingRound${index + 1}`] = roundPayload;
        });

        return payload;
    };


    useEffect(() => {
        if (!isHydrated) return;

        let roundLogicPayload: any = {};

        if (input?.[`DragForNow${seq.input}`]?.GameMode === "CategoryMatching") {
            roundLogicPayload = {
                gameMode: "CategoryMatching",
                categoryRounds: buildCategoryMatchingPayload(categoryRounds),
            };
        } else if (input?.[`DragForNow${seq.input}`]?.GameMode === "Ranking") {
            roundLogicPayload = {
                gameMode: "Ranking",
                rankingRounds: buildRankingPayload(rankingRounds),
            };
        } else {
            roundLogicPayload = buildRoundLogicPayload(rounds);
        }

        handleInput({
            target: {
                name: `DragForNow${seq.input}`,
                id: "roundLogic",
                value: roundLogicPayload,
            },
        });
    }, [
        rounds,
        categoryRounds,
        rankingRounds,
        input?.[`DragForNow${seq.input}`]?.GameMode,
        isHydrated,
    ]);



    // useEffect(() => {
    //     if (!isHydrated) return;

    //     // Build the complete roundLogic payload based on GameMode
    //     let roundLogicPayload: any = {};

    //     if (input?.[`DragForNow${seq.input}`]?.GameMode === 'CategoryMatching') {
    //         // For Category Matching mode, include category rounds
    //         roundLogicPayload = {
    //             gameMode: 'CategoryMatching',
    //             categoryRounds: buildCategoryMatchingPayload(categoryRounds)
    //         };
    //     } else if (input?.[`DragForNow${seq.input}`]?.GameMode === 'Ranking') {
    //         // For Ranking mode, include ranking rounds
    //         roundLogicPayload = {
    //             gameMode: 'Ranking',
    //             rankingRounds: buildRankingPayload(rankingRounds)
    //         };
    //     } else {
    //         // For Traditional mode, use the original structure
    //         roundLogicPayload = buildRoundLogicPayload(rounds);
    //     }

    //     handleInput({
    //         target: {
    //             name: `DragForNow${seq.input}`,
    //             id: "roundLogic",
    //             value: roundLogicPayload,
    //         },
    //     });
    // }, [rounds, categoryRounds, rankingRounds, input?.[`DragForNow${seq.input}`]?.GameMode, isHydrated]);

    // Handle Category Matching rounds
    useEffect(() => {
        if (!isHydrated) return;

        handleInput({
            target: {
                name: `DragForNow${seq.input}`,
                id: "categoryRounds",
                value: categoryRounds,
            },
        });
    }, [categoryRounds, isHydrated]);

    // Handle Ranking rounds
    useEffect(() => {
        if (!isHydrated) return;

        handleInput({
            target: {
                name: `DragForNow${seq.input}`,
                id: "rankingRounds",
                value: rankingRounds,
            },
        });
    }, [rankingRounds, isHydrated]);




    const safeParseJSON = (value: any) => {
        if (!value) return null;

        if (typeof value === "object") return value;

        if (typeof value === "string") {
            try {
                return JSON.parse(value);
            } catch (err) {
                console.error("Invalid roundLogic JSON", err);
                return null;
            }
        }

        return null;
    };
    const convertRankingRoundLogic = (roundLogic: any) => {
        if (!roundLogic?.rankingRounds) return [];

        return Object.values(roundLogic.rankingRounds).map((round: any) => {
            const statementsObj = round.statements || {};
            const statements: any[] = [];

            let i = 1;
            while (statementsObj[`statementText${i}`]) {
                statements.push({
                    statementText: statementsObj[`statementText${i}`] || "",
                    correctAnswer: statementsObj[`correctAnswer${i}`] || "",
                    feedback: statementsObj[`feedback${i}`] || "",
                });
                i++;
            }

            return { statements };
        });
    };
    const convertCategoryRoundLogic = (roundLogic: any) => {
        if (!roundLogic?.categoryRounds) return [];

        return Object.values(roundLogic.categoryRounds).map((round: any) => {
            const categories: any[] = [];
            const statements: any[] = [];

            // Categories
            Object.keys(round.categories || {}).forEach((key) => {
                categories.push({ categoryName: round.categories[key] });
            });

            // Statements
            let i = 1;
            while (round.statements?.[`statementText${i}`] !== undefined) {
                statements.push({
                    statementText: round.statements[`statementText${i}`] ?? "",
                    feedback: round.statements[`feedback${i}`] ?? "",
                    selectedCategory:
                        round.statements[`selectedCategory${i}`] ??
                        round.statements[`selectedCategory`] ??
                        "",
                });
                i++;
            }

            return { categories, statements };
        });
    };



    const convertRoundLogicToRounds = (roundLogic: any): Round[] => {
        if (!roundLogic || typeof roundLogic !== "object") return [];

        return Object.values(roundLogic).map((round: any) => ({
            Statement: round.Statement || "",
            feedback: round.feedback || "",
            correctAnswer: round.correctAnswer || "",
        }));
    };


    const backendReplay = weHaveChoose?.ShowReplay;
    // normalize EVERYTHING to boolean
    // Backend: true = enabled, false = disabled, "On"/"Off" = legacy, null = disabled
    const isReplayChecked =
        backendReplay === true ||
        backendReplay === "On" ||
        backendReplay === 1 ||
        backendReplay === "1";



    return (
        <Flex padding={'10px 0'} alignItems={'start'} overflowY={'hidden'}>
            <Box className="block-action-icons">
                <Tooltip hasArrow label="Choose New Block">
                    <div>
                        <Icon
                            as={MdAdd}
                            transitionDelay={'0s !important'}
                            fontSize={'18px'}
                            color={'grey'}
                            mr={'10px'}
                            cursor={'pointer'}
                            onClick={() => getSeq(seq, index, name)}
                        />
                    </div>
                </Tooltip>
                <Tooltip hasArrow label="Duplicate">
                    <div>
                        <Icon
                            as={BiSolidDuplicate}
                            transitionDelay={'0.1s !important'}
                            fontSize={'18px'}
                            color={'grey'}
                            mr={'10px'}
                            cursor={'pointer'}
                            onClick={() =>
                                duplicateSeq(seq, index, name, input?.[`DragForNow${seq.input}`])
                            }
                        />
                    </div>
                </Tooltip>
                <Tooltip hasArrow label="Delete DragForNow">
                    <div>
                        <Icon
                            as={MdDelete}
                            transitionDelay={'0.2s !important'}
                            fontSize={'18px'}
                            color={'grey'}
                            cursor={'pointer'}
                            onClick={() => delSeq(seq, index, name)}
                        />
                    </div>
                </Tooltip>
            </Box>
            <Box
                className="block-id"
                mr={'10px'}
                w={'50px'}
                fontSize={'17px'}
                color={'#1b2559'}
                fontWeight={'700'}
            >
                {seq.id}
            </Box>

            {/* <SimpleGrid
                columns={{ base: 1, md: 2, lg: 4 }}
                spacing={2}
            > */}
            {/* game mode */}

            <div className='flex self-stretch flex-row flex-1 w-full'>
                <Tabs defaultValue="general" className="h-full flex self-stretch w-full flex flex-col">
                    <TabsList className="flex w-full items-center">
                        <TabsTrigger value="general"
                            className="flex flex-1 items-center px-4 py-2 gap-2 text-slate-600 transition-all duration-200 data-[state=active]:shadow-md data-[state=active]:rounded-md data-[state=active]:bg-white data-[state=active]:text-slate-900">
                            <div className='flex flex-1 items-center justify-center px-4 py-2 gap-2'>
                                <FileText className="h-4 w-4" />
                                General Info
                            </div>
                        </TabsTrigger>
                        <TabsTrigger value="rounds"
                            className="flex flex-1 items-center px-4 py-2 gap-2 text-slate-600 transition-all duration-200 data-[state=active]:shadow-md data-[state=active]:rounded-md data-[state=active]:bg-white data-[state=active]:text-slate-900">
                            <div className='flex flex-1 items-center justify-center px-4 py-2 gap-2'>
                                <Layers className="h-4 w-4" />
                                Rounds & Questions
                            </div>
                        </TabsTrigger>
                        <TabsTrigger value="settings"
                            className="flex flex-1 items-center px-4 py-2 gap-2 text-slate-600 transition-all duration-200 data-[state=active]:shadow-md data-[state=active]:rounded-md data-[state=active]:bg-white data-[state=active]:text-slate-900">
                            <div className='flex flex-1 items-center justify-center px-4 py-2 gap-2'>
                                <Settings className="h-4 w-4" />
                                Settings
                            </div>
                        </TabsTrigger>
                    </TabsList>

                    <TabsContent value="general" className="flex flex-col gap-4 mt-[20px] self-stretch">
                        <Text fontSize="13px" fontWeight="600" color="#1b2559">
                            Game Mode
                        </Text>

                        {/* Game Mode */}
                        <Box display="flex" flexDirection="row" gap="16px">
                            {/* Category Matching */}
                            <label style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <input
                                    id="GameMode"
                                    type="radio"
                                    name={`DragForNow${seq.input}`}
                                    value="CategoryMatching"
                                    checked={
                                        input?.[`DragForNow${seq.input}`]?.GameMode ===
                                        'CategoryMatching'
                                    }
                                    onChange={(e) => handleInput(e)}
                                />
                                Category Matching
                            </label>

                            {/* Ranking */}
                            <label style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <input
                                    id="GameMode"
                                    type="radio"
                                    name={`DragForNow${seq.input}`}
                                    value="Ranking"
                                    checked={
                                        input?.[`DragForNow${seq.input}`]?.GameMode === 'Ranking'
                                    }
                                    onChange={(e) => handleInput(e)}
                                />
                                Ranking
                            </label>
                        </Box>

                        {/* title */}
                        {/* <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
                        Title
                    </Text> */}
                        <Box className="title" w="full" display="flex" >
                            <input
                                placeholder="Title"
                                id="MiniTitle"
                                className={`${seq.id}`}
                                name={`DragForNow${seq.input}`}
                                onChange={handleInput}
                                onClick={(e: any) => justClick(e, seq)}
                                value={input?.[`DragForNow${seq.input}`]?.MiniTitle || ''}
                                style={{
                                    overflow: 'hidden',
                                    border: validation?.[`DragForNow${seq.input}`]
                                        ? '2px solid red'
                                        : '1px solid #cbd5e1',
                                    borderRadius: '8px',
                                    padding: '8px 12px',
                                    outline: 'none',
                                    width: '100%',
                                }}
                            />
                        </Box>

                        {/* subtitle */}
                        <Box className="block-input-text" display="flex" w="full" >
                            <textarea
                                ref={textareaRef}
                                placeholder="Subtitle"
                                id="DragForNow"
                                className={`${seq.id}`}
                                name={`DragForNow${seq.input}`}
                                onChange={handleInput}
                                onClick={(e) => justClick(e, seq)}
                                value={input?.[`DragForNow${seq.input}`]?.DragForNow || ''}
                                style={{
                                    overflow: 'hidden',
                                    border: validation?.[`DragForNow${seq.input}`]
                                        ? '2px solid red'
                                        : '1px solid #cbd5e1', // default border color
                                    borderRadius: '8px', // ✅ border radius
                                    padding: '8px 12px',
                                    outline: 'none',
                                    width: '100%',
                                }}

                                tabIndex={0}

                            />

                        </Box>
                        {/*   left optiion */}
                        {/* <Box
                    className="Topic"
                    mb="10px"
                    w={{ base: '100%', lg: '200px' }}
                >
                    <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
                        Left Option
                    </Text>

                    <input
                        placeholder="WEAK"
                        id="leftOption"
                        className={`${seq.id}`}
                        name={`DragForNow${seq.input}`}
                        onChange={handleInput}
                        onClick={(e: any) => justClick(e, seq)}
                        value={input?.[`DragForNow${seq.input}`]?.leftOption || ''}
                        style={{
                            overflow: 'hidden',
                            border: validation?.[`DragForNow${seq.input}`]
                                ? '2px solid red'
                                : '1px solid #cbd5e1', // default border color
                            borderRadius: '8px', // ✅ border radius
                            padding: '8px 12px',
                            outline: 'none',
                        }}
                    />
                </Box> */}
                        {/* right option */}
                        {/* <Box
                    className="characterSubtitle"
                    mb="10px"
                    w={{ base: '100%', lg: '200px' }}
                >
                    <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
                        Right Option
                    </Text>

                    <input
                        placeholder="STRONG"
                        id="rightOption"
                        className={`${seq.id}`}
                        name={`DragForNow${seq.input}`}
                        onChange={handleInput}
                        onClick={(e: any) => justClick(e, seq)}
                        value={input?.[`DragForNow${seq.input}`]?.rightOption || ''}
                        style={{
                            overflow: 'hidden',
                            border: validation?.[`DragForNow${seq.input}`]
                                ? '2px solid red'
                                : '1px solid #cbd5e1', // default border color
                            borderRadius: '8px', // ✅ border radius
                            padding: '8px 12px',
                            outline: 'none',
                        }}
                    />
                </Box> */}
                        {/* Instruction Text */}
                        {/* <Box
                    className="characterSubtitle"
                    mb="10px"
                    w={{ base: '100%', lg: '200px' }}
                >
                    <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
                        Instruction Text
                    </Text>

                    <input
                        placeholder="Instruction Text"
                        id="instructionText"
                        className={`${seq.id}`}
                        name={`DragForNow${seq.input}`}
                        onChange={handleInput}
                        onClick={(e: any) => justClick(e, seq)}
                        value={input?.[`DragForNow${seq.input}`]?.instructionText || ''}
                        style={{
                            overflow: 'hidden',
                            border: validation?.[`DragForNow${seq.input}`]
                                ? '2px solid red'
                                : '1px solid #cbd5e1', // default border color
                            borderRadius: '8px', // ✅ border radius
                            padding: '8px 12px',
                            outline: 'none',
                        }}
                    />
                </Box> */}
                        {/* Statement Label */}
                        {/* <Box
                    className="characterSubtitle"
                    mb="10px"
                    w={{ base: '100%', lg: '200px' }}
                >
                    <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
                        Statement Label
                    </Text>

                    <input
                        placeholder="Statement Label"
                        id="statementLabel"
                        className={`${seq.id}`}
                        name={`DragForNow${seq.input}`}
                        onChange={handleInput}
                        onClick={(e: any) => justClick(e, seq)}
                        value={input?.[`DragForNow${seq.input}`]?.statementLabel || ''}
                        style={{
                            overflow: 'hidden',
                            border: validation?.[`DragForNow${seq.input}`]
                                ? '2px solid red'
                                : '1px solid #cbd5e1', // default border color
                            borderRadius: '8px', // ✅ border radius
                            padding: '8px 12px',
                            outline: 'none',
                        }}
                    />
                </Box> */}
                    </TabsContent>

                    <TabsContent value="settings" className="flex flex-col gap-4 mt-[20px] self-stretch">
                        {/* score */}
                        <Box className="score">
                            <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
                                Points per Correct Answer
                            </Text>

                            <input
                                placeholder="score"
                                type='number'
                                id="PointsPerCorrectScore"
                                className={`${seq.id}`}
                                name={`DragForNow${seq.input}`}
                                onChange={handleInput}
                                onClick={(e: any) => justClick(e, seq)}
                                value={input?.[`DragForNow${seq.input}`]?.PointsPerCorrectScore || ''}
                                style={{
                                    overflow: 'hidden',
                                    border: validation?.[`DragForNow${seq.input}`]
                                        ? '2px solid red'
                                        : '1px solid #cbd5e1', // default border color
                                    borderRadius: '8px', // ✅ border radius
                                    padding: '8px 12px',
                                    outline: 'none',
                                }}
                            />
                        </Box>
                        {/* correct answer */}
                        {/* <Box
                    className="score"
                    mb="10px"
                    w={{ base: '100%', lg: '200px' }}
                >
                    <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
                        correct answer
                    </Text>

                    <input
                        placeholder="correct answer"
                        id="CorrectAnswerFeedback"
                        className={`${seq.id}`}
                        name={`DragForNow${seq.input}`}
                        onChange={handleInput}
                        onClick={(e: any) => justClick(e, seq)}
                        value={input?.[`DragForNow${seq.input}`]?.CorrectAnswerFeedback || ''}
                        style={{
                            overflow: 'hidden',
                            border: validation?.[`DragForNow${seq.input}`]
                                ? '2px solid red'
                                : '1px solid #cbd5e1', // default border color
                            borderRadius: '8px', // ✅ border radius
                            padding: '8px 12px',
                            outline: 'none',
                        }}
                    />
                </Box> */}
                        {/* wrong answer */}
                        {/* <Box
                    className="score"
                    mb="10px"
                    w={{ base: '100%', lg: '200px' }}
                >
                    <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
                        wrong answer
                    </Text>

                    <input
                        placeholder="correct answer"
                        id="WrongAnswerFeedback"
                        className={`${seq.id}`}
                        name={`DragForNow${seq.input}`}
                        onChange={handleInput}
                        onClick={(e: any) => justClick(e, seq)}
                        value={input?.[`DragForNow${seq.input}`]?.WrongAnswerFeedback || ''}
                        style={{
                            overflow: 'hidden',
                            border: validation?.[`DragForNow${seq.input}`]
                                ? '2px solid red'
                                : '1px solid #cbd5e1', // default border color
                            borderRadius: '8px', // ✅ border radius
                            padding: '8px 12px',
                            outline: 'none',
                        }}
                    />
                </Box> */}
                        {/* range meter */}



                        {/* Label + Switch */}
                        <div className="flex items-center justify-between "

                            onClick={() => {
                                // unlock on first interaction
                                if (isSwitchDisabled) {
                                    setTimerUnlocked(true);

                                    handleInput({
                                        target: {
                                            id: "timerEnabled",
                                            name: `DragForNow${seq.input}`,
                                            value: true, // first enable
                                        },
                                    });
                                }
                            }}
                        >
                            <p className="text-[13px] font-semibold text-[#1b2559]">
                                Enable Timer
                            </p>
                            <Switch
                                isChecked={isSwitchChecked}
                                isDisabled={isSwitchDisabled}
                                pointerEvents={isSwitchDisabled ? "none" : "auto"}
                                onChange={(e) =>
                                    handleInput({
                                        target: {
                                            id: "timerEnabled",
                                            name: `DragForNow${seq.input}`,
                                            value: e.target.checked, // boolean
                                        },
                                    })
                                }
                            />

                        </div>

                        <div className='flex gap-4'>
                            <p className="text-[13px] font-semibold text-[#1b2559]">
                                Time per Round
                            </p>

                            {/* Optional value display */}
                            {rangeEnabled && (
                                <p className="text-xs text-muted-foreground text-right">
                                    {input?.[`DragForNow${seq.input}`]?.Timerlimit ?? 0}
                                </p>
                            )}
                        </div>
                        {/* Range Slider */}
                        {rangeEnabled && (
                            <div className="space-y-1 w-full">
                                <input
                                    type="range"
                                    min={0}
                                    max={120}
                                    className='w-full flex flex-1'
                                    value={Number(weHaveChoose?.Timerlimit ?? 0)}
                                    onChange={(e) =>
                                        handleInput({
                                            target: {
                                                id: "Timerlimit",
                                                name: `DragForNow${seq.input}`,
                                                value: Number(e.target.value),
                                            },
                                        })
                                    }
                                />
                            </div>
                        )}

                        {/* replay */}

                        <div className="flex items-center justify-between ">
                            <p className="text-[13px] font-semibold text-[#1b2559]">
                                Allow Replay
                            </p>
                            <div className='flex gap-4 mr-[10px] '>
                                <Text fontSize="12px" fontWeight="600" color={isReplayChecked ? "green.500" : "red.500"} >
                                    {isReplayChecked ? "Replay Enabled" : "Replay Disabled"}
                                </Text>
                                <Switch
                                    id="ShowReplay"
                                    isChecked={weHaveChoose?.ShowReplay === true || weHaveChoose?.ShowReplay === 1}
                                    onChange={(e) => {
                                        handleInput({
                                            target: {
                                                name: `DragForNow${seq.input}`,
                                                id: "ShowReplay",
                                                value: e.target.checked,
                                            },
                                        });
                                    }}
                                />
                            </div>
                        </div>

                        {/* Streak Messages */}

                        <Box className="score flex flex-col gap-3">
                            <Text fontSize="13px" fontWeight="600" color="#1b2559">
                                Streak Messages (Optional)
                            </Text>

                            <div className='flex flex-col gap-2'>
                                <div className='w-full flex gap-4'>
                                    <div className='flex flex-col flex-1 self-stretch'>
                                        <Text fontSize="13px" fontWeight="600" color="#1b2559">
                                            2-Streak
                                        </Text>

                                        <input
                                            placeholder=" 2-Streak"
                                            type='text'
                                            id="Streak2message"
                                            className={`${seq.id}`}
                                            name={`DragForNow${seq.input}`}
                                            onChange={handleInput}
                                            onClick={(e: any) => justClick(e, seq)}
                                            value={input?.[`DragForNow${seq.input}`]?.Streak2message || ''}
                                            style={{
                                                overflow: 'hidden',
                                                border: validation?.[`DragForNow${seq.input}`]
                                                    ? '2px solid red'
                                                    : '1px solid #cbd5e1',
                                                borderRadius: '8px',
                                                padding: '8px 12px',
                                                outline: 'none',
                                            }}
                                        />
                                    </div>

                                    <div className='flex flex-col flex-1 self-stretch'>
                                        <Text fontSize="13px" fontWeight="600" color="#1b2559" >
                                            3-Streak
                                        </Text>

                                        <input

                                            placeholder=" 3-Streak"
                                            type='text'
                                            id="Streak3message"
                                            className={`${seq.id}`}
                                            name={`DragForNow${seq.input}`}
                                            onChange={handleInput}
                                            onClick={(e: any) => justClick(e, seq)}
                                            value={input?.[`DragForNow${seq.input}`]?.Streak3message || ''}
                                            style={{
                                                overflow: 'hidden',
                                                border: validation?.[`DragForNow${seq.input}`]
                                                    ? '2px solid red'
                                                    : '1px solid #cbd5e1',
                                                borderRadius: '8px',
                                                padding: '8px 12px',
                                                outline: 'none',
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className='w-full flex gap-4'>
                                    <div className='flex flex-col flex-1 self-stretch'>
                                        <Text fontSize="13px" fontWeight="600" color="#1b2559" >
                                            4-Streak
                                        </Text>

                                        <input
                                            type='text'
                                            placeholder="4-Streak"
                                            id="Streak4message"
                                            className={`${seq.id}`}
                                            name={`DragForNow${seq.input}`}
                                            onChange={handleInput}
                                            onClick={(e: any) => justClick(e, seq)}
                                            value={input?.[`DragForNow${seq.input}`]?.Streak4message || ''}
                                            style={{
                                                overflow: 'hidden',
                                                border: validation?.[`DragForNow${seq.input}`]
                                                    ? '2px solid red'
                                                    : '1px solid #cbd5e1', // default border color
                                                borderRadius: '8px', // ✅ border radius
                                                padding: '8px 12px',
                                                outline: 'none',
                                            }}
                                        />
                                    </div>
                                    <div className='flex flex-col flex-1 self-stretch'>
                                        <Text fontSize="13px" fontWeight="600" color="#1b2559">
                                            4-Streak
                                        </Text>

                                        <input
                                            type='text'
                                            placeholder="5-Streak"
                                            id="Streak5message"
                                            className={`${seq.id}`}
                                            name={`DragForNow${seq.input}`}
                                            onChange={handleInput}
                                            onClick={(e: any) => justClick(e, seq)}
                                            value={input?.[`DragForNow${seq.input}`]?.Streak5message || ''}
                                            style={{
                                                overflow: 'hidden',
                                                border: validation?.[`DragForNow${seq.input}`]
                                                    ? '2px solid red'
                                                    : '1px solid #cbd5e1', // default border color
                                                borderRadius: '8px', // ✅ border radius
                                                padding: '8px 12px',
                                                outline: 'none',
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Box>
                        {/* congratulation message */}
                        {/* low score */}
                        <div className='flex flex-col gap-3'>
                            <Text fontSize="13px" fontWeight="600" color="#1b2559">
                                Congratulatory Message
                            </Text>

                            <Box className="score flex flex-col gap-2">
                                <Text fontSize="13px" fontWeight="600"  color="#1b2559">
                                    Low Score
                                </Text>

                                <div className='flex gap-4'>
                                    <div className='flex flex-col flex-1'>
                                        <Text fontSize="13px" fontWeight="600"  color="#1b2559">
                                            Min %
                                        </Text>

                                        <input
                                            placeholder="Min Score"
                                            type='number'
                                            id="Minlowscore"
                                            className={`${seq.id}`}
                                            name={`DragForNow${seq.input}`}
                                            onChange={handleInput}
                                            onClick={(e: any) => justClick(e, seq)}
                                            value={input?.[`DragForNow${seq.input}`]?.Minlowscore || ''}
                                            style={{
                                                overflow: 'hidden',
                                                border: validation?.[`DragForNow${seq.input}`]
                                                    ? '2px solid red'
                                                    : '1px solid #cbd5e1',
                                                borderRadius: '8px',
                                                padding: '8px 12px',
                                                outline: 'none',
                                            }}
                                        />
                                    </div>
                                    <div className='flex flex-col flex-1'>
                                        <Text fontSize="13px" fontWeight="600"  color="#1b2559" >
                                            Max %
                                        </Text>

                                        <input
                                            placeholder="Max Score"
                                            type='number'
                                            id="Maxlowscore"
                                            className={`${seq.id}`}
                                            name={`DragForNow${seq.input}`}
                                            onChange={handleInput}
                                            onClick={(e: any) => justClick(e, seq)}
                                            value={input?.[`DragForNow${seq.input}`]?.Maxlowscore || ''}
                                            style={{
                                                overflow: 'hidden',
                                                border: validation?.[`DragForNow${seq.input}`]
                                                    ? '2px solid red'
                                                    : '1px solid #cbd5e1',
                                                borderRadius: '8px',
                                                padding: '8px 12px',
                                                outline: 'none',
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='flex flex-1 w-full flex-col' >
                                    <Text fontSize="13px" fontWeight="600" color="#1b2559" >
                                        Message
                                    </Text>

                                    <input
                                        placeholder="Message"
                                        id="LowScoreMessage"
                                        className={`${seq.id}`}
                                        name={`DragForNow${seq.input}`}
                                        onChange={handleInput}
                                        onClick={(e: any) => justClick(e, seq)}
                                        value={input?.[`DragForNow${seq.input}`]?.LowScoreMessage || ''}
                                        style={{
                                            overflow: 'hidden',
                                            border: validation?.[`DragForNow${seq.input}`]
                                                ? '2px solid red'
                                                : '1px solid #cbd5e1', // default border color
                                            borderRadius: '8px', // ✅ border radius
                                            padding: '8px 12px',
                                            outline: 'none',
                                        }}
                                    />
                                </div>
                            </Box>

                            {/* medium Score */}
                            <Box className="score flex flex-col gap-2" >
                                <Text fontSize="13px" fontWeight="600" color="#1b2559">
                                    Medium Score
                                </Text>

                                <div className='flex gap-4'>
                                    <div className='flex flex-col flex-1' >
                                        <Text fontSize="13px" fontWeight="600"  color="#1b2559">
                                            Min %
                                        </Text>

                                        <input
                                            placeholder="Min Score"
                                            id="Minmediumscore"
                                            type='number'
                                            className={`${seq.id}`}
                                            name={`DragForNow${seq.input}`}
                                            onChange={handleInput}
                                            onClick={(e: any) => justClick(e, seq)}
                                            value={input?.[`DragForNow${seq.input}`]?.Minmediumscore || ''}
                                            style={{
                                                overflow: 'hidden',
                                                border: validation?.[`DragForNow${seq.input}`]
                                                    ? '2px solid red'
                                                    : '1px solid #cbd5e1',
                                                borderRadius: '8px',
                                                padding: '8px 12px',
                                                outline: 'none',
                                            }}
                                        />
                                    </div>
                                    <div className='flex flex-col flex-1' >
                                        <Text fontSize="13px" fontWeight="600" color="#1b2559" >
                                            Max %
                                        </Text>

                                        <input
                                            type='number'
                                            placeholder="Max Score"
                                            id="Maxmediumscore"
                                            className={`${seq.id}`}
                                            name={`DragForNow${seq.input}`}
                                            onChange={handleInput}
                                            onClick={(e: any) => justClick(e, seq)}
                                            value={input?.[`DragForNow${seq.input}`]?.Maxmediumscore || ''}
                                            style={{
                                                overflow: 'hidden',
                                                border: validation?.[`DragForNow${seq.input}`]
                                                    ? '2px solid red'
                                                    : '1px solid #cbd5e1',
                                                borderRadius: '8px',
                                                padding: '8px 12px',
                                                outline: 'none',
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='flex flex-1 w-full flex-col'>
                                    <Text fontSize="13px" fontWeight="600" color="#1b2559">
                                        Message
                                    </Text>

                                    <input
                                        placeholder="Message"
                                        id="MediumScoreMessage"
                                        className={`${seq.id}`}
                                        name={`DragForNow${seq.input}`}
                                        onChange={handleInput}
                                        onClick={(e: any) => justClick(e, seq)}
                                        value={input?.[`DragForNow${seq.input}`]?.MediumScoreMessage || ''}
                                        style={{
                                            overflow: 'hidden',
                                            border: validation?.[`DragForNow${seq.input}`]
                                                ? '2px solid red'
                                                : '1px solid #cbd5e1', // default border color
                                            borderRadius: '8px', // ✅ border radius
                                            padding: '8px 12px',
                                            outline: 'none',
                                        }}
                                    />
                                </div>
                            </Box>

                            {/* High Score */}
                            <Box className="score flex flex-col gap-2" >
                                <Text fontSize="13px" fontWeight="600" color="#1b2559" >
                                    High Score
                                </Text>
                                <div className='flex gap-4'>
                                    <div className='flex flex-col flex-1'>
                                        <Text fontSize="13px" fontWeight="600" color="#1b2559">
                                            Min %
                                        </Text>

                                        <input
                                            placeholder="Min Score"
                                            type='number'
                                            id="Minhighscore"
                                            className={`${seq.id}`}
                                            name={`DragForNow${seq.input}`}
                                            onChange={handleInput}
                                            onClick={(e: any) => justClick(e, seq)}
                                            value={input?.[`DragForNow${seq.input}`]?.Minhighscore || ''}
                                            style={{
                                                overflow: 'hidden',
                                                border: validation?.[`DragForNow${seq.input}`]
                                                    ? '2px solid red'
                                                    : '1px solid #cbd5e1',
                                                borderRadius: '8px',
                                                padding: '8px 12px',
                                                outline: 'none',
                                            }}
                                        />
                                    </div>
                                    <div className='flex flex-col flex-1'>
                                        <Text fontSize="13px" fontWeight="600" color="#1b2559">
                                            Max %
                                        </Text>

                                        <input
                                            placeholder="Max Score"
                                            type='number'
                                            id="Maxhighscore"
                                            className={`${seq.id}`}
                                            name={`DragForNow${seq.input}`}
                                            onChange={handleInput}
                                            onClick={(e: any) => justClick(e, seq)}
                                            value={input?.[`DragForNow${seq.input}`]?.Maxhighscore || ''}
                                            style={{
                                                overflow: 'hidden',
                                                border: validation?.[`DragForNow${seq.input}`]
                                                    ? '2px solid red'
                                                    : '1px solid #cbd5e1',
                                                borderRadius: '8px',
                                                padding: '8px 12px',
                                                outline: 'none',
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='flex flex-1 w-full flex-col'>
                                    <Text fontSize="13px" fontWeight="600" color="#1b2559" >
                                        Message
                                    </Text>

                                    <input
                                        placeholder="Message"
                                        id="highScoreMessage"
                                        className={`${seq.id}`}
                                        name={`DragForNow${seq.input}`}
                                        onChange={handleInput}
                                        onClick={(e: any) => justClick(e, seq)}
                                        value={input?.[`DragForNow${seq.input}`]?.highScoreMessage || ''}
                                        style={{
                                            overflow: 'hidden',
                                            border: validation?.[`DragForNow${seq.input}`]
                                                ? '2px solid red'
                                                : '1px solid #cbd5e1', // default border color
                                            borderRadius: '8px', // ✅ border radius
                                            padding: '8px 12px',
                                            outline: 'none',
                                        }}
                                    />
                                </div>
                            </Box>
                        </div>
                    </TabsContent>

                    {/* ================= DYNAMIC ROUNDS LOGIC ================= */}
                    <TabsContent value="rounds" className="flex flex-col gap-4 mt-[20px] self-stretch">
                        <Box mt={6}>
                            <Flex justify="space-between" align="center" mb={4}>
                                <Text fontSize="16px" fontWeight="700">
                                    Rounds
                                </Text>

                                {/* Add Round Button based on GameMode */}
                                {input?.[`DragForNow${seq.input}`]?.GameMode === 'CategoryMatching' && (
                                    <Button size="sm" colorScheme="blue" onClick={addCategoryRound}>
                                        + Add Category Round
                                    </Button>
                                )}
                                {input?.[`DragForNow${seq.input}`]?.GameMode === 'Ranking' && (
                                    <Button size="sm" colorScheme="blue" onClick={addRankingRound}>
                                        + Add Ranking Round
                                    </Button>
                                )}
                                {(!input?.[`DragForNow${seq.input}`]?.GameMode || input?.[`DragForNow${seq.input}`]?.GameMode === 'Traditional') && (
                                    <Button size="sm" colorScheme="blue" onClick={addRound}>
                                        + Add Round
                                    </Button>
                                )}
                            </Flex>

                            {/* Category Matching Mode UI */}
                            {input?.[`DragForNow${seq.input}`]?.GameMode === 'CategoryMatching' && (
                                <>
                                    {categoryRounds.map((round, rIndex) => (
                                        <Box
                                            key={rIndex}
                                            border="1px solid #e2e8f0"
                                            borderRadius="10px"
                                            p={4}
                                            mb={5}
                                        >
                                            <Flex justify="space-between" align="center" mb={3}>
                                                <Text fontWeight="600">Category Round {rIndex + 1}</Text>

                                                <Button
                                                    size="xs"
                                                    colorScheme="red"
                                                    variant="outline"
                                                    onClick={() => deleteCategoryRound(rIndex)}
                                                    isDisabled={categoryRounds.length === 1}
                                                >
                                                    Delete Round
                                                </Button>
                                            </Flex>

                                            {/* Categories Section */}
                                            <Box mb={4}>
                                                <Text fontSize="14px" fontWeight="600" mb="2px" color="#1b2559">
                                                    Categories
                                                </Text>
                                                {round.categories.map((category: any, cIndex: number) => (
                                                    <Flex key={cIndex} align="center" mb={2} gap={2}>
                                                        <Input
                                                            placeholder={`Category ${cIndex + 1} Name`}
                                                            value={category.categoryName}
                                                            onChange={(e) => updateCategoryRound(rIndex, 'categories', cIndex, 'categoryName', e.target.value)}
                                                            style={{
                                                                border: validation?.[`DragForNow${seq.input}`]
                                                                    ? '2px solid red'
                                                                    : '1px solid #cbd5e1',
                                                                borderRadius: '8px',
                                                                padding: '8px 12px',
                                                                outline: 'none',
                                                            }}
                                                        />
                                                        <Button
                                                            size="md"
                                                            colorScheme="green"
                                                            onClick={() => addCategory(rIndex)}
                                                            isDisabled={round.categories.length >= 5}
                                                        >
                                                            Add
                                                        </Button>
                                                        <Button
                                                            size="md"
                                                            colorScheme="red"
                                                            variant="outline"
                                                            onClick={() => deleteCategory(rIndex, cIndex)}
                                                            isDisabled={round.categories.length <= 2}
                                                        >
                                                            Delete
                                                        </Button>
                                                    </Flex>
                                                ))}
                                            </Box>

                                            {/* Statements Section */}
                                            <Box>
                                                <Text fontSize="14px" fontWeight="600" mb="2px" color="#1b2559">
                                                    Statements
                                                </Text>
                                                {round.statements.map((statement: any, sIndex: number) => (
                                                    <Box key={sIndex} border="1px solid #e2e8f0" borderRadius="8px" p={3} mb={3}>
                                                        <Flex justify="space-between" align="center" mb={2}>
                                                            <Text fontSize="13px" fontWeight="600">Statement {sIndex + 1}</Text>
                                                            <Button
                                                                size="xs"
                                                                colorScheme="red"
                                                                variant="outline"
                                                                onClick={() => deleteStatement(rIndex, sIndex)}
                                                                isDisabled={round.statements.length <= 1}
                                                            >
                                                                Delete Statement
                                                            </Button>
                                                        </Flex>
                                                        {/* STATEMENT TEXT */}
                                                        <Box mb={2}>
                                                            <Text fontSize="12px" fontWeight="500" mb="1px" color="#666">
                                                                Statement Text
                                                            </Text>
                                                            <Input
                                                                placeholder="Enter statement text"
                                                                value={statement.statementText}
                                                                onChange={(e) => updateCategoryRound(rIndex, 'statements', sIndex, 'statementText', e.target.value)}
                                                                style={{
                                                                    border: validation?.[`DragForNow${seq.input}`]
                                                                        ? '2px solid red'
                                                                        : '1px solid #cbd5e1',
                                                                    borderRadius: '8px',
                                                                    padding: '8px 12px',
                                                                    outline: 'none',
                                                                }}
                                                            />
                                                        </Box>
                                                        {/* correct category */}
                                                        <Box mb={2}>
                                                            <Text fontSize="12px" fontWeight="500" mb="1px" color="#666">
                                                                Statement Text
                                                            </Text>

                                                        </Box>
                                                        {/* FEEDBACK FOR CategoryMatching  */}
                                                        <Box>
                                                            <Text fontSize="12px" fontWeight="500" mb="1px" color="#666">
                                                                Feedback
                                                            </Text>
                                                            <Input
                                                                placeholder="Enter feedback text"
                                                                value={statement.feedback}
                                                                onChange={(e) => updateCategoryRound(rIndex, 'statements', sIndex, 'feedback', e.target.value)}
                                                                style={{
                                                                    border: validation?.[`DragForNow${seq.input}`]
                                                                        ? '2px solid red'
                                                                        : '1px solid #cbd5e1',
                                                                    borderRadius: '8px',
                                                                    padding: '8px 12px',
                                                                    outline: 'none',
                                                                }}
                                                            />
                                                        </Box>

                                                        {/* Category Selection Dropdown */}
                                                        <Box mb={2}>
                                                            <Text fontSize="12px" fontWeight="500" mb="1px" color="#666">
                                                                Select Category
                                                            </Text>
                                                            <ChakraSelect
                                                                placeholder="Select category..."
                                                                value={statement.selectedCategory || ''}
                                                                onChange={(e: any) => updateCategoryRound(rIndex, 'statements', sIndex, 'selectedCategory', e.target.value)}
                                                                style={{
                                                                    border: validation?.[`DragForNow${seq.input}`]
                                                                        ? '2px solid red'
                                                                        : '1px solid #cbd5e1',
                                                                    borderRadius: '8px',
                                                                    padding: '8px 12px',
                                                                    outline: 'none',
                                                                }}
                                                            >
                                                                {round.categories.map((category: any, cIndex: number) => (
                                                                    <option key={cIndex} value={category.categoryName}>
                                                                        {category.categoryName}
                                                                    </option>
                                                                ))}
                                                            </ChakraSelect>
                                                        </Box>

                                                    </Box>
                                                ))}

                                                <Button
                                                    size="sm"
                                                    colorScheme="blue"
                                                    onClick={() => addStatement(rIndex)}
                                                    mt={2}
                                                >
                                                    + Add Statement
                                                </Button>
                                            </Box>
                                        </Box>
                                    ))}
                                </>
                            )}

                            {/* Ranking Mode UI */}
                            {input?.[`DragForNow${seq.input}`]?.GameMode === 'Ranking' && (
                                <>
                                    {rankingRounds.map((round, rIndex) => (
                                        <Box
                                            key={rIndex}
                                            border="1px solid #e2e8f0"
                                            borderRadius="10px"
                                            p={4}
                                            mb={5}
                                        >
                                            <Flex justify="space-between" align="center" mb={3}>
                                                <Text fontWeight="600">Ranking Round {rIndex + 1}</Text>

                                                <Button
                                                    size="xs"
                                                    colorScheme="red"
                                                    variant="outline"
                                                    onClick={() => deleteRankingRound(rIndex)}
                                                    isDisabled={rankingRounds.length === 1}
                                                >
                                                    Delete Round
                                                </Button>
                                            </Flex>

                                            {/* Statements Section */}
                                            <Box>
                                                <Text fontSize="14px" fontWeight="600" mb="2px" color="#1b2559">
                                                    Statements
                                                </Text>
                                                {round.statements.map((statement: any, sIndex: number) => (
                                                    <Box key={sIndex} border="1px solid #e2e8f0" borderRadius="8px" p={3} mb={3}>
                                                        <Flex justify="space-between" align="center" mb={2}>
                                                            <Text fontSize="13px" fontWeight="600">Statement {sIndex + 1}</Text>
                                                            <Button
                                                                size="xs"
                                                                colorScheme="red"
                                                                variant="outline"
                                                                onClick={() => deleteRankingStatement(rIndex, sIndex)}
                                                                isDisabled={round.statements.length <= 1}
                                                            >
                                                                Delete Statement
                                                            </Button>
                                                        </Flex>
                                                        {/* STATEMENT TEXT */}
                                                        <Box mb={2}>
                                                            <Text fontSize="12px" fontWeight="500" mb="1px" color="#666">
                                                                Statement Text
                                                            </Text>
                                                            <Input
                                                                placeholder="Enter statement text"
                                                                value={statement.statementText}
                                                                onChange={(e) => updateRankingRound(rIndex, 'statements', sIndex, 'statementText', e.target.value)}
                                                                style={{
                                                                    border: validation?.[`DragForNow${seq.input}`]
                                                                        ? '2px solid red'
                                                                        : '1px solid #cbd5e1',
                                                                    borderRadius: '8px',
                                                                    padding: '8px 12px',
                                                                    outline: 'none',
                                                                }}
                                                            />
                                                        </Box>
                                                        {/* correct rank */}
                                                        <Box mb={2}>
                                                            <Text fontSize="12px" fontWeight="500" mb="1px" color="#666">
                                                                Correct Rank
                                                            </Text>
                                                            <Input
                                                                placeholder="Enter correct rank"
                                                                value={statement.correctAnswer}
                                                                onChange={(e) => updateRankingRound(rIndex, 'statements', sIndex, 'correctAnswer', e.target.value)}
                                                                style={{
                                                                    border: validation?.[`DragForNow${seq.input}`]
                                                                        ? '2px solid red'
                                                                        : '1px solid #cbd5e1',
                                                                    borderRadius: '8px',
                                                                    padding: '8px 12px',
                                                                    outline: 'none',
                                                                }}
                                                            />
                                                        </Box>
                                                        {/* feedback */}
                                                        <Box>
                                                            <Text fontSize="12px" fontWeight="500" mb="1px" color="#666">
                                                                Hint / Feedback for Wrong Answer (optional)
                                                            </Text>
                                                            <Input
                                                                placeholder="Enter feedback text"
                                                                value={statement.feedback}
                                                                onChange={(e) => updateRankingRound(rIndex, 'statements', sIndex, 'feedback', e.target.value)}
                                                                style={{
                                                                    border: validation?.[`DragForNow${seq.input}`]
                                                                        ? '2px solid red'
                                                                        : '1px solid #cbd5e1',
                                                                    borderRadius: '8px',
                                                                    padding: '8px 12px',
                                                                    outline: 'none',
                                                                }}
                                                            />
                                                        </Box>
                                                    </Box>
                                                ))}

                                                <Button
                                                    size="sm"
                                                    colorScheme="blue"
                                                    onClick={() => addRankingStatement(rIndex)}
                                                    mt={2}
                                                >
                                                    + Add Statement
                                                </Button>
                                            </Box>

                                        </Box>
                                    ))}
                                </>
                            )}
                        </Box>
                    </TabsContent>

                    {/* navigation */}
                    <Box
                        className="navigation-icon  justify-center items-center"
                        display={'flex'}
                        alignItems={'center'}
                        mt={'20px'}
                        width={'auto'}
                    >


                        <Flex>
                            <Box>
                                <Tooltip hasArrow label="Add Navigations">
                                    <div>
                                        <Menu
                                            tabState={'leadDialog'}
                                            id={seq.input}
                                            for={`DragForNow${seq.input}`}
                                            setNavigation={setNavigation}
                                            handleBlock={handleBlock}
                                            items={items}
                                            seq={seq}
                                        />
                                    </div>
                                </Tooltip>
                            </Box>
                            <Box
                                ml={'4px'}
                                cursor={'pointer'}
                                display={
                                    input?.[`DragForNow${seq.input}`]?.DragForNowleadShow ? 'block' : 'none'
                                }
                                zIndex={9999}
                            >
                                {input?.[`DragForNow${seq.input}`]?.DragForNowleadShow === 'New Block' &&
                                    !input?.[`DragForNow${seq.input}`]?.DragForNownavigate ? (
                                    // Render content for New Block
                                    <>
                                        <MiniBox1 seq={seq} i={index} />
                                    </>
                                ) : input?.[`DragForNow${seq.input}`]?.DragForNowleadShow ===
                                    'Select Block' &&
                                    !input?.[`DragForNow${seq.input}`]?.DragForNownavigate ? (
                                    // Render select tag for Select Block
                                    <ChakraSelect
                                        placeholder={'Blocks...'}
                                        id="Dialog"
                                        name={`DragForNow${seq.input}`}
                                        value={
                                            showSelectBlock.find(
                                                (option: any) =>
                                                    option.value ==
                                                    input?.[`DragForNow${seq.input}`]?.DragForNownavigate,
                                            )?.value || ''
                                        }
                                        onChange={(e: any) =>
                                            handleSelectBlock(
                                                { value: e.target.value },
                                                seq.input,
                                                `DragForNow${seq.input}`,
                                                `DragForNow${seq.input}`,
                                            )
                                        }
                                    >
                                        {showSelectBlock.filter(
                                            (option: any) => option.value !== seq.input,
                                        ).map((option: any) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </ChakraSelect>
                                ) : (
                                    // Render content for the 'else' condition
                                    <>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <StrightConector
                                                name={
                                                    input?.[`DragForNow${seq.input}`]?.DragForNowleadShow ===
                                                        'New Block'
                                                        ? showSelectBlock.find(
                                                            (option: any) =>
                                                                option.value ==
                                                                input?.[`DragForNow${seq.input}`]?.DragForNownavigate,
                                                        )?.label
                                                        : input?.[`DragForNow${seq.input}`]?.DragForNowleadShow ===
                                                            'Select Block'
                                                            ? showSelectBlock.find(
                                                                (option: any) =>
                                                                    option.value ==
                                                                    input?.[`DragForNow${seq.input}`]?.DragForNownavigate,
                                                            )?.label
                                                            : input?.[`DragForNow${seq.input}`]?.DragForNownavigate
                                                }
                                            />
                                        </div>
                                    </>
                                )}
                            </Box>
                        </Flex>
                    </Box>

                    {/* </SimpleGrid> */}

                </Tabs>
            </div>
        </Flex >

    );
};

export default DragForNowCompo;

